import React from 'react';

export function Blank() {

    return (
      <></>
    )
}